import React from 'react';
import { useRole } from '@/hooks/useRole';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

type AppRole = 'Inspector' | 'Supervisor' | 'Admin';

interface RequireRoleProps {
  roles: AppRole[];
  children: React.ReactNode;
  redirectTo?: string;
}

export function RequireRole({ roles, children, redirectTo = '/' }: RequireRoleProps) {
  const { loading, isAdmin, isSupervisor, isInspector } = useRole();

  // Wait for permissions to load before making any routing decision
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-wire3-green" />
      </div>
    );
  }

  const roleToPermission: Record<AppRole, boolean> = {
    Admin: isAdmin,
    Supervisor: isSupervisor,
    Inspector: isInspector,
  };

  const hasRole = roles.some(r => roleToPermission[r]);

  if (!hasRole) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}